import { render } from "./DocPageFooterPref.vue?vue&type=template&id=62873fba&scoped=true"
import script from "./DocPageFooterPref.vue?vue&type=script&lang=js"
export * from "./DocPageFooterPref.vue?vue&type=script&lang=js"

import "./DocPageFooterPref.vue?vue&type=style&index=0&id=62873fba&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62873fba"]])

export default __exports__